import { Fragment } from "react";

import TrendDownIcon from "@uui/ArrowCircleDownRight";
import TrendUpIcon from "@uui/ArrowCircleUpRight";

import Typography from "@mui/material/Typography";

import HighlightChip, {
  HighlightChipProps,
} from "@app/analytics/MeetingReport/components/HighlightChip";
import { titleize } from "@app/utils/utils";

import { Row } from "@rui/Stack";

import {
  Block,
  BlockQuote,
  Card,
  ImpactChip,
  MetricLabel,
  MetricValue,
  Timestamp,
} from "./styles";

export interface DetailedHighlightProps {
  description: string;
  label?: {
    metric: string;
    value?: string;
    impact: {
      value: string;
      direction: "positive" | "negative" | "neutral";
    };
  };
  timestamp?: string;
  type: HighlightChipProps["type"];
}

const ICON_BY_IMPACT_DIRECTION = {
  positive: <TrendUpIcon />,
  negative: <TrendDownIcon />,
  neutral: <Fragment />,
};

const DetailedHighlight = ({
  description,
  label,
  timestamp,
  type,
}: DetailedHighlightProps) => {
  const isReactionHighlight = type === "positive" || type === "negative";
  const DescriptionWrapper = isReactionHighlight ? BlockQuote : Fragment;

  const trendIcon =
    isReactionHighlight && label
      ? ICON_BY_IMPACT_DIRECTION[label.impact.direction]
      : null;

  return (
    <Card>
      <Row variant="apart">
        <Row spacing={1}>
          <HighlightChip type={type} />
          {timestamp && <Timestamp>{timestamp}</Timestamp>}
        </Row>
        {label && (
          <Row spacing={1} variant="right">
            <MetricLabel>
              {titleize(label.metric)}:{" "}
              {label.value != null && <MetricValue>{label.value}</MetricValue>}
            </MetricLabel>
            <ImpactChip type={label.impact.direction}>
              {trendIcon}
              {label.impact.value}
            </ImpactChip>
          </Row>
        )}
      </Row>
      <Block>
        <DescriptionWrapper>
          <Typography>{description}</Typography>
        </DescriptionWrapper>
      </Block>
    </Card>
  );
};

export default DetailedHighlight;
